import React from 'react'
import PropTypes from 'prop-types'
import Sticky from 'react-stickynode'
import {
  CX,
  BREAKPOINT_EXTRA_SMALL,
  BREAKPOINT_SMALL,
  BREAKPOINT_MEDIUM,
} from '../constants'
import { me } from '../initial_state'
import LoggedOutSidebar from '../components/sidebar/logged_out_sidebar'
import DefaultSidebar from '../components/sidebar/default_sidebar'
import SidebarPanelGroup from '../components/sidebar_panel_group'
import DefaultNavigationBar from '../components/navigation_bar/default_navigation_bar'
import LoggedOutNavigationBar from '../components/navigation_bar/logged_out_navigation_bar'
import FooterBar from '../components/footer_bar'
import FloatingActionButton from '../components/floating_action_button'
import Pills from '../components/pills'
import GlobalFooter from '../components/global_footer'
import WrappedBundle from '../features/ui/util/wrapped_bundle'
import PullToRefresh from '../components/pull_to_refresh'
import { isIOS15, isPWA } from '../utils/is_mobile';
import {
  SidebarXS,
} from '../features/ui/util/async_components'
import { connect } from 'react-redux'

class Layout extends React.PureComponent {
  render() {
    const {
      actions,
      children,
      layout,
      noComposeButton,
      noRightSidebar,
      noSidebar,
      page,
      showBackBtn,
      showLinkFooterInSidebar,
      showGlobalFooter,
      tabs,
      title,
      button,
      search,
      sidebarChildren,
      slimLayout,
      noPullToRefresh,
      width,
      showNormalSidebar,
    } = this.props

    const isXS = width <= BREAKPOINT_EXTRA_SMALL
    const isSmall = !isXS && width <= BREAKPOINT_SMALL
    const isMedium = !isXS && !isSmall && width <= BREAKPOINT_MEDIUM
    const isLarge = width >= BREAKPOINT_MEDIUM

    const noPaddingPages = ['group', 'messages', 'list', 'explore', 'list-create', 'business']
    const hasPadding = noPaddingPages.indexOf(page) === -1

    const mainBlockClasses = CX({
      d: 1,
      w1015PX: slimLayout,
      w100PC: !slimLayout,
      flexRow: 1,
      jcEnd: 1,
      ml5: slimLayout,
      py15: hasPadding,
      pb15: hasPadding,
    })
    const mainBlockClassesXS = [_s.d, _s.w100PC, _s.jcEnd, _s.pb15].join(' ')

    const containerClasses = CX({
      d: 1,
      flexRow: 1,
      w100PC: 1,
      flexGrow1: 1,
      jcCenter: slimLayout,
    })

    const wrapperClasses = CX({
      d: 1,
      w100PC: isXS,
      flexShrink1: !isXS,
      flexGrow1: !slimLayout && !isXS,
    })

    const sidebarClasses = CX({
      d: 1,
      w340PX: 1,
      pr15: !slimLayout && isLarge,
      pr10: slimLayout || !isLarge,
      pl15: slimLayout,
    })

    const shouldShowNormalSidebar = !!me || showNormalSidebar

    return (
      <div className={[_s.d, _s.w100PC, _s.minH100VH, _s.bgTertiary].join(' ')}>

        { isXS && <WrappedBundle component={SidebarXS} /> }

        {
          me &&
          <DefaultNavigationBar
            page={page}
            actions={actions}
            tabs={tabs}
            title={title}
            shrinkSearch={!!search}
            showBackBtn={showBackBtn}
          />
        }

        { me && (!isIOS15() || isPWA()) && !noPullToRefresh && <PullToRefresh /> }
        { !me && <LoggedOutNavigationBar title={title} /> }

        <div className={containerClasses}>
          {
            !noSidebar && !isXS &&
            <>
              {
                shouldShowNormalSidebar &&
                <DefaultSidebar
                  page={page}
                  actions={actions}
                  showBackBtn={showBackBtn}
                  tabs={tabs}
                  title={title}
                  search={search}
                  button={button}
                  slimLayout={slimLayout}
                  sidebarChildren={sidebarChildren}
                />
              }
              {
                !shouldShowNormalSidebar &&
                <LoggedOutSidebar
                  showBackBtn={showBackBtn}
                  tabs={tabs}
                  title={title}
                  showLinkFooter={showLinkFooterInSidebar}
                  sidebarChildren={sidebarChildren}
                />
              }
            </>
          }

          <div className={wrapperClasses}>
            <main role='main'>
              <div className={isXS ? mainBlockClassesXS : mainBlockClasses}>
                
                {
                  noRightSidebar && 
                  <>
                   {
                      !!tabs && isXS &&
                      <div className={[_s.d, _s.pt10, _s.pb5, _s.borderColorSecondary, _s.bgPrimary, _s.borderBottom1PX].join(' ')}>
                        <Pills pills={tabs} wrap />
                      </div>
                    }
                    {children}
                  </>
                 }

                {
                  !noRightSidebar &&
                  <div className={[_s.d, _s.w645PX, _s.z1, _s.mlAuto, _s.mrAuto].join(' ')}>
                    {
                      !!tabs && isXS &&
                      <div className={[_s.d, _s.pt10, _s.pb5, _s.borderColorSecondary, _s.bgPrimary, _s.borderBottom1PX].join(' ')}>
                        <Pills pills={tabs} wrap />
                      </div>
                    }

                    <div className={_s.d}>
                      {children}
                    </div>
                  </div>
                }

                {
                  !noRightSidebar && !isSmall && !isXS &&
                  <div className={[_s.d, _s.w340PX].join(' ')}>
                    <Sticky top={73} enabled>
                      <div className={sidebarClasses}>
                        <SidebarPanelGroup layout={layout} page={page} />
                      </div>
                    </Sticky>
                  </div>
                }

                { !noComposeButton && <FloatingActionButton /> }

              </div>
            </main>
          </div>
        </div>

        { isXS && <FooterBar title={title} /> }
        { !me && showGlobalFooter && <GlobalFooter /> }
      </div>
    )
  }

}

const mapStateToProps = (state) => ({
  width: state.getIn(['settings', 'window_dimensions', 'width'])
})

Layout.propTypes = {
  actions: PropTypes.array,
  children: PropTypes.node,
  layout: PropTypes.array,
  slimLayout: PropTypes.bool,
  noComposeButton: PropTypes.bool,
  noRightSidebar: PropTypes.bool,
  noSidebar: PropTypes.bool,
  page: PropTypes.string,
  showBackBtn: PropTypes.bool,
  showLinkFooterInSidebar: PropTypes.bool,
  showGlobalFooter: PropTypes.bool,
  tabs: PropTypes.array,
  title: PropTypes.string,
}

export default connect(mapStateToProps)(Layout)
